/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    SelectProps,
} from '@mui/material';
import {withFormikField} from 'src/utils/formik';
import ArrowDown from 'src/assets/arrowDone.svg';

interface ZsSelectProps extends SelectProps {
    data: Array<{
        value: string;
        label: string;
        disabled?: boolean;
        key?: string;
        icon?: any;
    }>;
    required?: boolean;
    disabled?: boolean;
}

export const ZsSelect: React.FC<ZsSelectProps> = ({
                                                      data,
                                                      required = false,
                                                      disabled = false,
                                                      ...props
                                                  }) => (
    <Box style={{position: 'relative'}}>
        <FormControl
            required={required}
            variant="outlined"
            fullWidth
            disabled={disabled}
        >
                <Select
                    IconComponent={(props) => (
                        <img
                            src={ArrowDown}
                            alt={''}
                            {...props}
                            style={{top: 'auto', paddingRight: '9px', paddingLeft: '9px'}}
                        />
                    )}
                    {...props}
                >
                    {data?.map((item) => (
                        <MenuItem
                            key={item.key ? item.key : item.value}
                            value={item.value}
                            disabled={item.disabled}
                        >
                            <Box style={{display: 'flex', alignItems: 'center', height: '100%'}}>
                                {item.label}{' '}
                                {item.icon && item.icon}
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
        </FormControl>
    </Box>
);

const ZsFormikSelect = withFormikField(ZsSelect);

export default ZsFormikSelect;
